import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ExperiencePage = lazy(() => import('../pages/experience/page'));
const ProjectsPage = lazy(() => import('../pages/projects/page'));
const QualificationsPage = lazy(() => import('../pages/qualifications/page'));
const PhilosophyPage = lazy(() => import('../pages/philosophy/page'));
const WritingPage = lazy(() => import('../pages/writing/page'));
const WritingDetailPage = lazy(() => import('../pages/writing/detail/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const BriefingsPage = lazy(() => import('../pages/briefings/page'));
const BriefingDetailPage = lazy(() => import('../pages/briefings/detail/page'));
const WorkshopsPage = lazy(() => import('../pages/workshops/page'));
const PersonaLabPage = lazy(() => import('../pages/workshops/persona-lab/page'));
const PersonaWorkshopPage = lazy(() => import('../pages/workshops/persona-workshop/page'));
const PersonaBaseballCardToolPage = lazy(() => import('../pages/workshops/persona-baseball-card-tool/page'));
const WorkshopDetailPage = lazy(() => import('../pages/workshops/detail/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/experience',
    element: <ExperiencePage />,
  },
  {
    path: '/projects',
    element: <ProjectsPage />,
  },
  {
    path: '/qualifications',
    element: <QualificationsPage />,
  },
  {
    path: '/philosophy',
    element: <PhilosophyPage />,
  },
  {
    path: '/writing',
    element: <WritingPage />,
  },
  {
    path: '/writing/:id',
    element: <WritingDetailPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/briefings',
    element: <BriefingsPage />,
  },
  {
    path: '/briefings/:slug',
    element: <BriefingDetailPage />,
  },

  {
    path: '/workshops',
    element: <WorkshopsPage />,
  },
  {
    path: '/workshops/persona-lab',
    element: <PersonaLabPage />,
  },
  {
    path: '/workshops/persona-workshop',
    element: <PersonaWorkshopPage />,
  },
  {
    path: '/workshops/persona-baseball-card-tool',
    element: <PersonaBaseballCardToolPage />,
  },
  {
    path: '/workshops/:slug',
    element: <WorkshopDetailPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
